import styled from 'styled-components'

export default styled.div`
	width: max-content;
	display: flex;
	align-items: center;
	border-radius: 3px;
	background: #fbfbfb;
	border: 1px solid #dddddd;
	padding: 3px 8px;
	font-weight: 400;
	font-size: 12px;
	line-height: 18px;
	color: #333333;
`
